<div mat-dialog-title> {{data.title}}</div>
<mat-dialog-content>{{data.text}}</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" (click)="closeOk()">Да</button>
    <button mat-raised-button (click)="closeCancel()">Отмена</button>
</mat-dialog-actions>
